import * as React from "react";
import {cx} from "emotion";

import "./expansion.scss";

import {applyResultCart} from "@APMUI/routes/checkout/common/apply-result-cart";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {setNestedValue} from "@Common/utils/arr-path";
import {cascadeFind}    from "@Common/utils/cascade";
import {chain}          from "@Common/utils/fs";
import {equalDeep}      from "@Common/utils/objects";

import {AppliedCopay}     from "./applied-copay/applied-copay";
import {CalculateForm}    from "./calculate-form/calculate-form";
import {OtherOrdersTable} from "./other-orders-table/other-orders-table";

export const Expansion = ({form, appliedCopay, itemId, store, onRemovedCopay, pending, submitted}) => cs(

    ["otherCopays" , (_, next) => next(
        store.cart.paymentErrors?.copays?.find((c) => c.itemId == itemId && c.copayCredits?.length)?.copayCredits ??
        store.cart.appliedCredits?.copays?.find((c) => c.itemId == itemId && c.copayCredits?.length)?.copayCredits
    )],
    consumeContext("apis"),
    ({otherCopays, apis}) => (
        <div className={cx("expansion expansion-2i2", {calculated: appliedCopay})}>
            {CalculateForm({
                formFields: form.fields,

                pending,
                calculated: appliedCopay,
                disabled: pending.value != null && equalDeep(submitted.value, pending.value),
                onSubmit: async () => {
                    await store.dispatch(setCopay(
                        {
                            form: form.toReq(pending.value),
                            itemId,
                        },
                        {apis}
                    ));
                    submitted.onChange(pending.value);
                },
            })}

            {appliedCopay && (
                AppliedCopay({
                    appliedCopay,
                    onRemove: async () => {
                        await store.dispatch(removeCopay({itemId}, {apis}));
                        onRemovedCopay();
                        submitted.onChange(null);
                    },
                })
            )}

            {!!otherCopays?.length && (
                OtherOrdersTable({
                    otherCopays,
                })
            )}
        </div>
    ),
);


const setCopay = ({form, itemId}, {apis}) => ({
    action: async (cart) => {


        const resultCart = await apis.next.cart.updateCart(chain(
            {cartId: cart.cartId,},

            // Removing old copay, may not be necessary as server will do it
            // (_) => chain(
            //     cascadeFind(cart, "appliedCredits.copays[*]", (copay) => copay.itemId == itemId && copay),
            //     (appliedCopay) => !appliedCopay ? _ : setNestedValue(
            //         _,
            //         ["removeCredits", "copays"],
            //         [appliedCopay]
            //     )
            // ),

            (_) => setNestedValue(_, ["credits", "copays!arr"], [
                {
                    itemId,
                    ...form,
                },
            ]),
        ));

        const errors = resultCart.paymentErrors?.copays?.find((c) => c.itemId == itemId && c.errors?.length)?.errors;
        const otherOrdersApplied = !!resultCart.paymentErrors?.copays?.find((c) => c.itemId == itemId && c.copayCredits?.length);
        const copayUnavailable = !resultCart.appliedCredits?.copays?.find((c) => c.itemId == itemId);

        if (errors?.length) {
            return {
                error: {
                    msg: errors[0],
                },
            };
        } else if (resultCart.errors?.length) {
            return {
                error: {
                    msg: resultCart.errors[0].msg,
                },
            };
        } else if (copayUnavailable) {
            if(otherOrdersApplied) {
                return({
                    change: applyResultCart(resultCart),
                    error: {
                        msg: "Copay is not available due to being used on other order(s)."
                    }
                })
            } else {
                return {
                    error: {
                        msg: "This order does not meet the requirements for copay usage. Please review the copay description for more information on what is needed to apply the copay for this order.",
                    }
                };
            }
        } else {
            return ({
                change: applyResultCart(resultCart),
            });
        }
    },
});

const removeCopay = ({itemId}, {apis}) => ({
    action: async (cart) => ({
        change: applyResultCart(await apis.next.cart.updateCart(chain(
            {cartId: cart.cartId},
            (_) => setNestedValue(
                _,
                ["removeCredits", "copays"],
                [
                    cascadeFind(cart, "appliedCredits.copays[*]", (copay) => copay.itemId == itemId && copay)
                ]
            ),
        ))),
    })
});
